import { render, staticRenderFns } from "./overview-info.vue?vue&type=template&id=bf3f0e1a&scoped=true&"
import script from "./overview-info.vue?vue&type=script&lang=js&"
export * from "./overview-info.vue?vue&type=script&lang=js&"
import style0 from "./overview-info.vue?vue&type=style&index=0&id=bf3f0e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3f0e1a",
  null
  
)

export default component.exports